export default {
  path: 'dashboard',
  name: 'dashboard',
  component: () => import(/* webpackChunkName: "Dashboard" */'@views/dashboard/Index'),
  meta: {
    title: 'data.menu.dashboard',
  }
};
